<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div class="d-flex justify-content-between header-container m-3">
  <h1 class="m-0 fw-bold fs-4">{{ titleText }}</h1>
  <div class="d-flex gap-2">
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" class="action-button"
            (click)="onSubmit()" [disabled]="selectedScenarios === null || selectedScenarios.length === 0">
      Select
    </button>
  </div>
</div>
<div class="set-height">
  <app-industry-scenario-select
    [titleText]="titleText"
    [validFcorgs]="validFcorgs"
    [isMultiSelect]="isMultiSelect"
    (confirmEvent)="onSelectEvent($event)">
  </app-industry-scenario-select>
</div>
